import { ForbiddenScreen } from '@shared/ui/layout';

export default function Forbidden() {
  return <ForbiddenScreen />;
}
